<footer class="footer">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-6 text-center text-sm-start">
                {{year}} © ALICRO SAS.
            </div>
            <div class="col-sm-6">
                <div class="text-sm-end d-none d-sm-block">
                    Design & Develop by Jam SoftCo - Versi&oacute;n: {{ version }}
                </div>
            </div>
        </div>
    </div>
</footer>